import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { REELS_VIDEO, REELS_POSTER, IMG } from "@/data/content";
import { Reveal, Overline } from "@/components/site/Reveal";
import Bubbles from "@/components/site/Bubbles";

export default function ReelsVideo() {
  const videoRef = useRef(null);
  const [started, setStarted] = useState(false);

  const play = () => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = false;
    v.play();
    setStarted(true);
  };

  return (
    <section className="relative overflow-hidden bg-ocean-deep py-24 md:py-32 light-rays" data-testid="reels-section">
      <Bubbles count={12} />
      <div className="relative z-10 mx-auto max-w-4xl px-6 lg:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <Overline className="text-sun">Veja com seus olhos</Overline>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[1.02] tracking-tight text-white sm:text-5xl">
            Assista e veja como <span className="text-sun-gradient">funciona nosso passeio</span>
          </h2>
          <p className="mt-4 text-base text-white/85 sm:text-lg">
            Não precisa saber nadar ou ter experiência alguma. O mergulho é acompanhado por um <strong className="font-bold text-white">instrutor particular</strong> do início ao fim.
          </p>
        </Reveal>

        <Reveal delay={0.1} className="mt-12 flex justify-center">
          <div className="relative w-full max-w-[320px] overflow-hidden rounded-[1.75rem] border border-white/15 bg-black shadow-2xl shadow-black/50" style={{ aspectRatio: "9 / 16" }} data-testid="reels-frame">
            {REELS_VIDEO ? (
              <>
                <video
                  ref={videoRef}
                  src={REELS_VIDEO}
                  poster={REELS_POSTER}
                  className="h-full w-full object-cover"
                  playsInline
                  loop
                  controls={started}
                  data-testid="reels-video"
                />
                {!started && (
                  <button
                    onClick={play}
                    className="absolute inset-0 flex items-center justify-center bg-ocean-deep/30 transition-colors hover:bg-ocean-deep/10"
                    aria-label="Reproduzir vídeo"
                    data-testid="reels-play"
                  >
                    <span className="flex h-20 w-20 items-center justify-center rounded-full cta-sun shadow-2xl">
                      <Play className="ml-1 h-8 w-8 text-white" fill="currentColor" />
                    </span>
                  </button>
                )}
              </>
            ) : (
              <div className="absolute inset-0 flex items-center justify-center">
                <img src={REELS_POSTER} alt="" className="absolute inset-0 h-full w-full object-cover opacity-55" />
                <span className="relative flex h-20 w-20 items-center justify-center rounded-full cta-sun shadow-2xl">
                  <Play className="ml-1 h-8 w-8 text-white" fill="currentColor" />
                </span>
              </div>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
